import Vuex from "vuex"
import Vue from "vue"
import phone from "./modules/phone"
import sysInit from "./modules/sysInit"
import drawer from "./modules/drawer"
Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    phone,
    sysInit,
    drawer
  }
});
